<ng-container *ngIf="!close">
  <div
    class="ds-message {{messageContainerClass}} d-flex p-3"
    [attr.role]="highlighted ? 'alert' : ''"
    [attr.aria-label]="messageContainerAriaLabel"
  >
    <em *ngIf="showIcon"
      class="ds-message__typeIcon ds-icon--big {{messageIconClass}} me-2 my-0"
      aria-hidden="true"
    ></em>
    <ng-container *ngIf="isMultiLine; else singleMessage">
      <ul class="ds-message__text ds-list mx-0 my-auto px-0">
        <li
          *ngFor="let m of messages"
          class="ds-list__item ds-bullet__item d-flex ds-message__text__list"
        >
          <span [innerHTML]="m"></span>
        </li>
      </ul>
    </ng-container>
    <ng-template #singleMessage>
      <p class="ds-message__text mx-0 my-auto">
        <span *ngIf="message" [innerHTML]="message"></span>
        <ng-content></ng-content>
      </p>
    </ng-template>
    <ng-container *ngIf="closable">
      <button
        #closeBtn
        class="ds-message__closeButton ms-4 me-0 my-0 p-1"
        aria-label="Close message"
        (click)="closeMessage()"
      >
        <em class="ds-icon ds-icon--close ds-message__closeButton__icon"></em>
      </button>
    </ng-container>
  </div>
</ng-container>
